import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { SupplementForm } from "~/components/form/health-profile/SupplementForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.supplement;

export default function EditSupplement() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const supplement = findMedical(type, id);

    if (!supplement) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="supplements">
            <SupplementForm supplement={supplement} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
